/**
 * Получить URL юридического документа по типу из appConfig.legalDocuments
 * @param {string} type - тип документа (например, 'user_agreement', 'privacy')
 * @returns {string} - URL документа или пустая строка
 */
export function getLegalDocumentUrl(type) {
    if (!type) {
        return '';
    }

    const legalDocuments = window.appConfig?.legalDocuments;

    if (!legalDocuments || typeof legalDocuments !== 'object') {
        return '';
    }

    return legalDocuments[type] || '';
}
